/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdministeredDrugValue
 */
export interface AdministeredDrugValue {
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    route?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    dosage?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    lot?: string;
    /**
     * 
     * @type {number}
     * @memberof AdministeredDrugValue
     */
    expiry_date?: number;
    /**
     * 
     * @type {number}
     * @memberof AdministeredDrugValue
     */
    given_date?: number;
    /**
     * 
     * @type {number}
     * @memberof AdministeredDrugValue
     */
    scheduled_date?: number;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    given_by?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    site?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    generate_id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdministeredDrugValue
     */
    attachments?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdministeredDrugValue
     */
    notes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdministeredDrugValue
     */
    paid?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdministeredDrugValue
     */
    price?: number;
}

/**
 * Check if a given object implements the AdministeredDrugValue interface.
 */
export function instanceOfAdministeredDrugValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function AdministeredDrugValueFromJSON(json: any): AdministeredDrugValue {
    return AdministeredDrugValueFromJSONTyped(json, false);
}

export function AdministeredDrugValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdministeredDrugValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'dosage': !exists(json, 'dosage') ? undefined : json['dosage'],
        'lot': !exists(json, 'lot') ? undefined : json['lot'],
        'expiry_date': !exists(json, 'expiry_date') ? undefined : json['expiry_date'],
        'given_date': !exists(json, 'given_date') ? undefined : json['given_date'],
        'scheduled_date': !exists(json, 'scheduled_date') ? undefined : json['scheduled_date'],
        'given_by': !exists(json, 'given_by') ? undefined : json['given_by'],
        'site': !exists(json, 'site') ? undefined : json['site'],
        'generate_id': !exists(json, 'generate_id') ? undefined : json['generate_id'],
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'paid': !exists(json, 'paid') ? undefined : json['paid'],
        'price': !exists(json, 'price') ? undefined : json['price'],
    };
}

export function AdministeredDrugValueToJSON(value?: AdministeredDrugValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'route': value.route,
        'dosage': value.dosage,
        'lot': value.lot,
        'expiry_date': value.expiry_date,
        'given_date': value.given_date,
        'scheduled_date': value.scheduled_date,
        'given_by': value.given_by,
        'site': value.site,
        'generate_id': value.generate_id,
        'attachments': value.attachments,
        'notes': value.notes,
        'paid': value.paid,
        'price': value.price,
    };
}

